module.exports = __webpack_public_path__ + "img/point1.45e2ab33.png";